module.exports = __webpack_public_path__ + "img/DAH.4bb5ce01.png";